export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const CONVERSATION_STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
};

export const CONVERSATION_PRIORITY = {
  URGENT: 'urgent',
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium',
};

export const CONVERSATION_PRIORITY_ORDER = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};

export const ALLOWED_FILE_TYPES =
  'image/*,' +
  'audio/*,' +
  'video/*,' +
  '.3gpp,' +
  'text/csv, text/plain, application/json, application/pdf, text/rtf,' +
  'application/xml, text/xml,' +
  'application/zip, application/x-7z-compressed application/vnd.rar application/x-tar,' +
  'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';

export const CSAT_RATINGS = [
  {
    key: 'disappointed',
    translationKey: 'CSAT.RATINGS.POOR',
    emoji: '😞',
    value: 1,
    color: '#FDAD2A',
  },
  {
    key: 'expressionless',
    translationKey: 'CSAT.RATINGS.FAIR',
    emoji: '😑',
    value: 2,
    color: '#FFC532',
  },
  {
    key: 'neutral',
    translationKey: 'CSAT.RATINGS.AVERAGE',
    emoji: '😐',
    value: 3,
    color: '#FCEC56',
  },
  {
    key: 'grinning',
    translationKey: 'CSAT.RATINGS.GOOD',
    emoji: '😀',
    value: 4,
    color: '#6FD86F',
  },
  {
    key: 'smiling',
    emoji: '😍',
    translationKey: 'CSAT.RATINGS.EXCELLENT',
    value: 5,
    color: '#44CE4B',
  },
];

export const CSAT_DISPLAY_TYPES = {
  EMOJI: 'emoji',
  STAR: 'star',
};

export const AUDIO_FORMATS = {
  WEBM: 'audio/webm',
  OGG: 'audio/ogg',
  MP3: 'audio/mp3',
  WAV: 'audio/wav',
};

export const MESSAGE_VARIABLES = [
  {
    label: 'Conversation Id',
    key: 'conversation.id',
  },
  {
    label: 'Contact Id',
    key: 'contact.id',
  },
  {
    label: 'Contact name',
    key: 'contact.name',
  },
  {
    label: 'Contact first name',
    key: 'contact.first_name',
  },
  {
    label: 'Contact last name',
    key: 'contact.last_name',
  },
  {
    label: 'Contact email',
    key: 'contact.email',
  },
  {
    label: 'Contact phone',
    key: 'contact.phone',
  },
  {
    label: 'Agent name',
    key: 'agent.name',
  },
  {
    label: 'Agent first name',
    key: 'agent.first_name',
  },
  {
    label: 'Agent last name',
    key: 'agent.last_name',
  },
  {
    label: 'Agent email',
    key: 'agent.email',
  },
  {
    key: 'inbox.name',
    label: 'Inbox name',
  },
  {
    label: 'Inbox id',
    key: 'inbox.id',
  },
  {
    label: 'Account name',
    key: 'account.name',
  },
];

export const DYNAMIC_MESSAGE_VARIABLES = [
  { key: 'clicktochat.ad_timestamp', label: 'Ad click time' },
  {
    key: 'clicktochat.ad_first_incoming_message',
    label: 'Ad first incoming message',
  },
  { key: 'clicktochat.ad_channel_id', label: 'Ad channel ID' },
  { key: 'clicktochat.ad_channel_type', label: 'Ad channel type' },
  { key: 'clicktochat.ad_contact_type', label: 'Ad contact type' },
  { key: 'clicktochat.ad_id', label: 'Ad ID' },
  { key: 'clicktochat.ad_name', label: 'Ad name' },
  { key: 'clicktochat.ad_campaign_id', label: 'Ad campaign ID' },
  { key: 'clicktochat.ad_campaign_name', label: 'Ad campaign name' },
  { key: 'clicktochat.ad_adset_id', label: 'Ad set ID' },
  { key: 'clicktochat.ad_adset_name', label: 'Ad set name' },
  { key: 'clicktochat.ad_ad_url', label: 'Ad URL' },
  { key: 'clicktochat.ad_reference', label: 'Ad reference' },
  { key: 'clicktochat.ad_status', label: 'Ad status' },
  { key: 'clicktochat.ad_objective', label: 'Ad objective' },
  { key: 'clicktochat.ad_optimization_goal', label: 'Ad optimization goal' },
  { key: 'clicktochat.ad_destination_type', label: 'Ad destination type' },
  { key: 'contact.id', label: 'Contact ID' },
  { key: 'contact.name', label: 'Contact name' },
  { key: 'contact.firstname', label: 'Contact first name' },
  { key: 'contact.lastname', label: 'Contact last name' },
  { key: 'contact.email', label: 'Contact email' },
  { key: 'contact.phone', label: 'Contact phone' },
  { key: 'assignee.id', label: 'Assignee ID' },
  { key: 'assignee.name', label: 'Assignee name' },
  { key: 'assignee.firstname', label: 'Assignee first name' },
  { key: 'assignee.lastname', label: 'Assignee last name' },
  { key: 'assignee.email', label: 'Assignee email' },
  { key: 'assignee.team', label: 'Assignee team' },
  { key: 'system.current_date', label: 'Current date' },
  { key: 'system.current_time', label: 'Current time' },
  { key: 'system.current_datetime', label: 'Current date and time' },
];

export const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
};

export const TWILIO_CONTENT_TEMPLATE_TYPES = {
  TEXT: 'text',
  MEDIA: 'media',
  QUICK_REPLY: 'quick_reply',
  CALL_TO_ACTION: 'call_to_action',
};
